// extracted by mini-css-extract-plugin
module.exports = {"power-backup-J":"J_power-backup-J__T9snx"};